<template>
    <!-- return item photo without css here -->
    <div v-bind:style="{ backgroundImage: 'url(' + mainItemImage + ')' }"></div>
</template>

<script>
import { appendImgHostUrl } from '@/store/dry'

export default {
    name: "ItemPhoto",
    props: {
        itemPhotos: {
            type: Array,
            required: true
        },
        hdQuality: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            mainItemImage: '',
            photoHolder: require('../../../../../public/img/web/portraitOLD.jpg'),
        }
    },
    methods: {
        mainItemPhoto(itemPhotosArr) {
            if(itemPhotosArr){
                let src = ""
                for(let x=0; x < itemPhotosArr.length; x++){
                    if(itemPhotosArr[x].main){
                        src = appendImgHostUrl(this.hdQuality ? itemPhotosArr[x].path : itemPhotosArr[x].thumbPath)
                    }
                }
                if(src !== ""){
                    return this.mainItemImage = src
                }
                return this.mainItemImage = this.photoHolder
            }
            return this.mainItemImage = this.photoHolder
        },
    },
    watch: {
        itemPhotos() {
            this.mainItemPhoto(this.itemPhotos)
        }
    },
    created() {
        this.mainItemPhoto(this.itemPhotos)
    }
}
</script>
